import { render, staticRenderFns } from "./top-review-large.vue?vue&type=template&id=44a0b160&"
import script from "./top-review-large.vue?vue&type=script&lang=js&"
export * from "./top-review-large.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports